/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Confirmation from 'components/Bookings/Confirmation/Confirmation'
import JourneyPlan from 'components/Bookings/JourneyPlan/JourneyPlan'
import TransportOptions from 'components/Bookings/TransportOptions/TransportOptions'
import { WizardStep } from 'components/RouteWizard/RouteWizard'
import Wizard from 'components/RouteWizard/Wizard'
import BaseLayout from 'layouts/Base/BaseLayout'
import React, { useEffect, useRef, useState } from 'react'
import { fireStartBookingProcess } from 'analytics/bookingEvents'
import useTwoFactor from './useTwoFactor'

type BookingData = {
  type: any
  account: any
  plan: any
  transport: any
  preview: any
}

type MiniBookingWizardData = {
  initialData: BookingData
}

const MiniBookingWizard = ({ initialData }: MiniBookingWizardData) => {
  const { isVerified, startTwoFactor } = useTwoFactor()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | undefined>()

  const startFiredRef = useRef(false)
  const fireStartOnce = () => {
    if (startFiredRef.current) return
    startFiredRef.current = true
    fireStartBookingProcess({ flow: 'mini' })
  }
  const steps: WizardStep<BookingData>[] = [
    {
      component: JourneyPlan,
      path: '/create',
      stepLabel: 'Journey Plan',
      selector: (data) => {
        if (data.plan == null) {
          return data.plan
        }

        const deserializeLeg = (leg: any) => {
          const ms = 1000 * 60 * 15
          const when =
            leg?.when != null
              ? new Date(Math.round(new Date(leg?.when)?.getTime() / ms) * ms)
              : new Date(Math.round(new Date()?.getTime() / ms) * ms)

          return {
            ...leg,
            when,
          }
        }

        return {
          ...data.plan,
          inbound: deserializeLeg(data.plan.inbound),
          outbound: deserializeLeg(data.plan.outbound),
        }
      },
      onSuccess: (data, formData) => {
        return {
          ...data,
          plan: formData.plan,
          preview: {
            ...data.preview,
            ...formData.preview,
          },
        }
      },
    },
    {
      component: TransportOptions,
      path: '/transport',
      stepLabel: 'Transport Options',
      selector: (data) => data.transport,
      onSuccess: (data, formData) => {
        return {
          ...data,
          transport: formData.transport,
          prices: formData.prices,
          preview: {
            ...data.preview,
            ...formData.preview,
          },
        }
      },
    },
    {
      component: Confirmation,
      path: '/confirmation',
      stepLabel: 'Confirmation',
      selector: (data) => data,
    },
  ]

  useEffect(() => {
    if (!isVerified) {
      startTwoFactor(initialData.account.mainPassenger.contactNumber)
    }
  }, [])

  return (
    <BaseLayout
      pageTitle="Create new booking"
      pageSubtitle="Complete the information and we'll quote your travel"
      titleSx={{ paddingTop: '0' }}
      mainElement={
        <div onFocusCapture={fireStartOnce} onChangeCapture={fireStartOnce}>
          <Wizard
            loading={loading}
            error={error}
            steps={steps}
            basePath={'booking/create'}
            initialData={initialData}
          />
        </div>
      }
    ></BaseLayout>
  )
}

export default MiniBookingWizard
